import { useSyncExternalStore } from "react";
import { resolvedTheme, subscribeTheme, type ThemeMode } from "./theme";

/**
 * The mode on screen right now, re-rendering when it changes — whether from
 * the toggle or from the OS under a viewer who has made no choice.
 */
export function useThemeMode(): ThemeMode {
  return useSyncExternalStore(subscribeTheme, resolvedTheme, () => "day");
}
